import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { HrGetPersonFormOptionsPathParameters } from 'api/actions/hr-get-person-form-options/hr-get-person-form-options-path-parameters';
import { HrGetPersonFormOptionsResponse } from 'api/actions/hr-get-person-form-options/hr-get-person-form-options-response';

type HrGetPersonFormOptionsQueryParameters = Record<string, any>;

/**
 * The path of the HrGetPersonFormOptions action.
 */
export const hrGetPersonFormOptionsActionPath = new SweetPath<keyof HrGetPersonFormOptionsPathParameters>(
  '/api/hr/people/form-options',
  { path: '{param}' }
);

/**
 * Creates a contextualized HrGetPersonFormOptions actions.
 */
export default function createHrGetPersonFormOptionsAction(axios: AxiosInstance) {
  return function hrGetPersonFormOptionsAction({
    headers = {},
    query = {},
  }: { headers?: AxiosRequestConfig<any>['headers']; query?: HrGetPersonFormOptionsQueryParameters } = {}) {
    const path = hrGetPersonFormOptionsActionPath.original;

    return axios.request<HrGetPersonFormOptionsResponse, HrGetPersonFormOptionsResponse>({
      method: 'get',
      url: path,
      params: query,

      headers,
    });
  };
}
